module.exports = {
      id: "comm-vikatan-plus-usage",
      viewBox: "0 0 484.569 52.881",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-vikatan-plus",
      toString: function () {
        return this.url;
      }
    }